import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { ExamDetails } from "../types";

const fetchExams = async (
	_tenantId: string,
	_appId: string,
): Promise<ExamDetails[]> => {
	const { data } = await authAxios.get(`${API_BASE_URL}/commerce/v1/exam-list`);
	return data.data;
};

export { fetchExams };
